import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Suppress benign ResizeObserver dev overlay error
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    if (overlay) overlay.style.display = 'none';
    if (overlayDiv) overlayDiv.style.display = 'none';
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
